export const common: EnvironmentInterface = {
    production: false,
    fallbackImageUrl: '/images/404.png',
    /**
     * Точки входа API, сохраняющие файлы в разные месте
     */
    FILE_UPLOAD_URLS: {
        Lab: '/api/file-uploader/upload',               // Только проект ЛАБ
        Noap: '/api/file-uploader/upload-nk-storage',   // Проекты ЛАБ и НОАП, но только для авторизованного пользователя
        Noap_public: '/api/file-uploader/upload-nk'     // Проекты ЛАБ и НОАП, файлы доступны по ссылке
    },
    apiUrl: '/api/',
    technicalSupportUrl: 'https://lab365.freshdesk.com/support/tickets/new',
    legalRulesUrl: 'https://lab365.ru/legal',
    updatePageUrl: 'https://lab365.ru/updates'
};


export interface EnvironmentInterface {
    production: boolean;

    /**
     * Url картинки, используемой для заглушки
     */
    fallbackImageUrl: string;

    /**
     * Префик для API запросов
     */
    apiUrl: string;

    /**
     * Ссылка на техподдержку
     */
    technicalSupportUrl: string;

    /**
     * Ссылка на правила хранения информации и лицензионное соглашение
     */
    legalRulesUrl: string;

    /**
     * Страница с новостями обновлений
     */
    updatePageUrl: string;

    /**
     * Точки API для загрузки файлов в разные стораджы:
     */
    FILE_UPLOAD_URLS: {
        /**
         * Публичный сторадж для проекта Lab365
         */
        Lab: string,

        /**
         * Приватный сторадж для проекта Nk365
         */
        Noap: string,

        /**
         * Публичный сторадж для проекта Nk365
         */
        Noap_public: string
    };
}
